import {
  Button,
  Divider,
  Grid,
  TablePagination,
} from "@mui/material";
import { makeStyles } from '@mui/styles';
import CheckCircle from "@mui/icons-material/CheckCircle";
import Cancel from "@mui/icons-material/Cancel";
import { green } from "@mui/material/colors";
import { red } from "@mui/material/colors";
import { dateTimeFormat } from "../../util/DateUtil";
import AccountCircle from "@mui/icons-material/AccountCircle";
import Loading from "../UI/Loading";
import TablePaginationActions from "../../shared/components/Table/Actions";

const useStyles = makeStyles({
  fotoComponent: {
    borderRadius: "20px",
    maxHeight: "80px",
  },
  accountCircleIcon: {
    fontSize: 80,
    color: "black",
  },
});

const UsuarioList = ({ usuarios, isLoading, handleChangePage, setUsuario }) => {
  const classes = useStyles();
  return (
    <Grid container direction="column" spacing={2}>
      {isLoading ? (
        <Loading description="Carregando Usuários..." />
      ) : (
        <>
          <Grid>
            <Button
              variant="outlined"
              onClick={() => setUsuario({ eNovo: true })}
            >
              Novo Usuário
            </Button>
          </Grid>
          {usuarios.content.map((u) => (
            <Grid>
              <Grid container direction="column" spacing={2}>
                <Grid>
                  <Grid container direction="row" spacing={4}>
                    <Grid size={2}>
                      <Grid
                        container
                        spacing={3}
                        direction="column"
                        alignItems="center"
                      >
                        <Grid>
                          {u.fileName ? (
                            <img
                              className={classes.fotoComponent}
                              src={u.fotoUrl}
                              alt=""
                            />
                          ) : (
                            <AccountCircle
                              className={classes.accountCircleIcon}
                            />
                          )}
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid size={4}>
                      <Grid
                        container
                        direction="column"
                        spacing={3}
                        alignItems="center"
                      >
                        <Grid>
                          <span style={{ fontWeight: "bold" }}>Nome:</span>{" "}
                          {u.nome}
                        </Grid>
                        <Grid>
                          <span style={{ fontWeight: "bold" }}>Email:</span>{" "}
                          {u.email}
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid size={3}>
                      <Grid
                        container
                        direction="column"
                        spacing={3}
                        alignItems="center"
                      >
                        <Grid>
                          <span style={{ fontWeight: "bold" }}>Perfil:</span>{" "}
                          {u.perfil}
                        </Grid>
                        <Grid>
                          <span style={{ fontWeight: "bold" }}>Ativo:</span>{" "}
                        </Grid>
                        <Grid>
                          {u.ativo ? (
                            <CheckCircle style={{ color: green[500] }} />
                          ) : (
                            <Cancel style={{ color: red[500] }} />
                          )}
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid size={3}>
                      <Grid
                        container
                        spacing={3}
                        direction="column"
                        alignItems="center"
                      >
                        <Grid>
                          <Button
                            variant="outlined"
                            onClick={() => setUsuario(u)}
                          >
                            Selecionar
                          </Button>
                        </Grid>
                        <Grid>
                          <span style={{ fontStyle: "italic" }}>
                            Último Acesso:{" "}
                            {u.dataUltimoAcesso
                              ? dateTimeFormat(u.dataUltimoAcesso)
                              : "--"}
                          </span>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid>
                  <Divider />
                </Grid>
              </Grid>
            </Grid>
          ))}
        </>
      )}
      <Grid>
        <TablePagination
          rowsPerPageOptions={[]}
          rowsPerPage={usuarios.size ? usuarios.size : 0}
          component="div"
          count={usuarios.totalElements}
          page={usuarios.number}
          onPageChange={handleChangePage}
          labelDisplayedRows={({ from, to, count }) =>
            from +
            "-" +
            to +
            " de " +
            (count !== -1 ? count + " registros" : +" mais de " + to)
          }
          ActionsComponent={TablePaginationActions}
        />
      </Grid>
    </Grid>
  );
};

export default UsuarioList;
